module.exports = __webpack_public_path__ + "img/og-whatsapp-logo.f961f7df.png";